import React from "react";

export default function PositionButtons() {
  function moveImage(pos) {
    let img = document.querySelector(".image");
    if (img !== null) {
      if (pos === "left") {
        img.style.cssText = `left: 0; transform:translate(0,-50%); border-top-left-radius: 0px; border-bottom-left-radius: 0px;
        `;
      } else if (pos === "right") {
        img.style.cssText = `left: 100%; transform:translate(-100%,-50%); border-top-right-radius: 0px; border-bottom-right-radius: 0px;
        `;
      } else if (pos === "top") {
        img.style.cssText = `top: 0; transform:translate(-50%, 0); border-top-right-radius: 0px; border-top-left-radius: 0px;
        `;
      } else if (pos === "bottom") {
        img.style.cssText = `top: 100%; transform:translate(-50%, -100%); border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;
        box-shadow: 10px 0 15px -5px rgba(0,0,0, .2),
        -10px 0 15px -5px rgba(0,0,0, .2);
        `;
      } else if (pos === "center") {
        img.style.cssText = `left: 50%;
        top: 50%;
        transform: translate(-50%,-50%); border-radius:25px;
        `;
      }
    }
  }

  function positionColorReset() {
    let buttons = document.querySelectorAll(".position-btn");
    buttons.forEach((button) => {
      button.firstChild.style.cssText = "background-color: #F5DF4D";
    });
  }
  function postionButtonColorize(side) {
    document.querySelector(`#position-${side}-inner`).style.cssText =
      "background-color: #851e3e";
  }

  return (
    <div className="position-btns">
      <div className="position-btn-wrapper">
        <button
          className="position-btn"
          onClick={() => {
            moveImage("center");
            positionColorReset();
            postionButtonColorize("center");
          }}
        >
          <div className="position-inner" id="position-center-inner">
            {" "}
          </div>
        </button>
      </div>
      <div className="position-btn-wrapper">
        <button
          className="position-btn"
          onClick={() => {
            moveImage("left");
            positionColorReset();
            postionButtonColorize("left");
          }}
        >
          <div className="position-inner" id="position-left-inner" />
        </button>
      </div>
      <div className="position-btn-wrapper">
        <button
          className="position-btn"
          onClick={() => {
            moveImage("right");
            positionColorReset();
            postionButtonColorize("right");
          }}
        >
          <div className="position-inner" id="position-right-inner">
            {" "}
          </div>
        </button>
      </div>
      <div className="position-btn-wrapper">
        <button
          className="position-btn"
          onClick={() => {
            moveImage("top");
            positionColorReset();
            postionButtonColorize("top");
          }}
        >
          <div className="position-inner" id="position-top-inner">
            {" "}
          </div>
        </button>
      </div>
      <div className="position-btn-wrapper">
        <button
          className="position-btn"
          onClick={() => {
            moveImage("bottom");
            positionColorReset();
            postionButtonColorize("bottom");
          }}
        >
          <div className="position-inner" id="position-bottom-inner">
            {" "}
          </div>
        </button>
      </div>
    </div>
  );
}
